import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { ProjectTreePanel } from '../../layout/MainPanels/ProjectTreePanel/ProjectTreePanel';
import { DragLayout } from '../../layout/DragLayout/DragLayout';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { LoaderForModal } from '../../shared/LoaderForModal/LoaderForModal';
import { fetchDepartmentsNetworkPending } from '../Datamanager/ViewportDepartmentNetwork/departments.slice';
import { fetchFeaturesPending } from '../LauncherConfiguration/Features/features.slice';
import { LoaderBackground } from '../../shared/LoaderBackground/LoaderBackground';
import { saveAllPaths } from '../UserSettings/FilePath/userSettingsFilePathFastChanging.slice';
import { Modal } from '../Modal/Modal';
import { fetchStagingDataPending } from '../Dashboard/DashboardStaging/staging.slice';
import { IBasicDetails } from '../../../interface/interfaces';
import { DragAndDropContextWrapper } from '../Dashboard/DashboardDragAndDrop/DragAndDropContextWrapper';
import { saveProjectPath } from '../UserSettings/ProjectPath/userSettingsProjectPathFastChanging.slice';
import { FlexCenter } from '../../layout/FlexCenter/FlexCenter';
import { BackgroundLoaderWrapper } from '../../layout/BackgroundLoaderWrapper/BackgroundLoaderWrapper';
import { fetchUserSettingsAllFilePathPending } from '../UserSettings/FilePath/userSettingsAllFilePaths.slice';
import { fetchUserSettingsProjectPathPending } from '../UserSettings/ProjectPath/userSettingsProjectPath.slice';
import { selectorConfigurationRoot } from './redux/configurationRoot.selector';
import { Allotment } from 'allotment';
import "allotment/dist/style.css";
import { SpacingCustom } from '../../layout/Spacing/SpacingCustom';


export const ConfigurationRoot = () => {

    const {
        webSocket,
        project, 
        loginUserAndTokenData, 
        userSettingsAllFilePath, 
        userSettingsProjectPath, 
        mergingAvatar, 
        createAndSendPassengers, 
        stagingList, 
        hostAndUsername,
        savedUserToken,
        defaultProjectPath,
        departments,
        featuresConfig,
        status,
        commits,
        trigger} = useAppSelector(selectorConfigurationRoot)

        const { receivedMessage } = webSocket;
        const { project: projectProp } = project;
        const { userAndTokenData } = loginUserAndTokenData;
        const {userSettingsAllFilePathData, userSettingsAllFilePathLoading} = userSettingsAllFilePath;
        const {userSettingsProjectPathData, userSettingsProjectPathLoading} = userSettingsProjectPath;
        const { merginData } = mergingAvatar;
        const {analyzerPassengerData} = createAndSendPassengers;
        const { stagingLoading} = stagingList;
        const {hostnameAndUsername} = hostAndUsername
        const {savedUserToken: savedUserTokenProp} = savedUserToken;
        const {defaultProjectPath: defaultProjectPathProp} = defaultProjectPath;
        const {departmentsNetworkLoading} = departments;
        const {featuresLoading} = featuresConfig;
        const {statusLoading} = status;
        const {commitsLoading} = commits;
        const {dashboardTrigger, launchFeatureTrigger} = trigger

    const dispatch = useAppDispatch();


    // save project path
    useEffect(() => {
        if(userSettingsProjectPathData){
            dispatch(saveProjectPath(userSettingsProjectPathData))
        }
    }, [userSettingsProjectPathData]);

    // save all paths
    useEffect(() => {
        if(userSettingsAllFilePathData.length !== 0)
            dispatch(saveAllPaths(userSettingsAllFilePathData))
    }, [userSettingsAllFilePathData]);

    //Get all features
    useEffect(() => {
        if (userAndTokenData) {
            dispatch(fetchFeaturesPending({ url: `project/${projectProp?._id}/tools-configuration`, token: userAndTokenData?.token }));
        }
    }, [dispatch, projectProp?._id, userAndTokenData]);

    //Get all departments
    useEffect(() => {
        if (userAndTokenData) {
            dispatch(fetchDepartmentsNetworkPending({ url: `project/${projectProp?._id}/departmentNetwork`, token: userAndTokenData?.token }));
        }
    }, [dispatch, projectProp?._id, userAndTokenData]);


    // Get all staging data
    useEffect(() => {
        if (userAndTokenData) {
            dispatch(fetchStagingDataPending({ url: `project/${projectProp?._id}/staging-list`, token: userAndTokenData?.token }));
        }
    }, [dispatch, userAndTokenData, projectProp?._id, merginData, analyzerPassengerData]);

    // get all file paths
    useEffect(()=>{
        dispatch(fetchUserSettingsAllFilePathPending({
            url:`${process.env.REACT_APP_USER_SETTINGS_API}/file-path/paths?user_id=${userAndTokenData?.user.uniqueId}&project_id=${projectProp?._id}&device_id=${hostnameAndUsername?.osHostName}_${hostnameAndUsername?.osUserName}`, 
            token:`${savedUserTokenProp}`
        }));
    },[dispatch, hostnameAndUsername, project, savedUserTokenProp, userAndTokenData, launchFeatureTrigger])

    // get project path
    useEffect(()=>{
        dispatch(fetchUserSettingsProjectPathPending({
            url:`${process.env.REACT_APP_USER_SETTINGS_API}/project-path/path?user_id=${userAndTokenData?.user.uniqueId}&project_id=${projectProp?._id}&device_id=${hostnameAndUsername?.osHostName}_${hostnameAndUsername?.osUserName}`, 
            token:`${savedUserTokenProp}`
        }));
    },[dispatch, hostnameAndUsername, project, savedUserTokenProp, userAndTokenData])



    return (
        <section className="staging-section">
            {/* FIX */}
            <BackgroundLoaderWrapper>
                <FlexCenter direction='h' position='start' gap={.5}>
                    {userSettingsAllFilePathLoading && <LoaderBackground label='Getting all tool paths...'/>  }
                    {userSettingsProjectPathLoading && <LoaderBackground label='Getting project path...'/>  }
                    {departmentsNetworkLoading && <LoaderBackground label='Getting departmens network ...'/>  }
                    {featuresLoading && <LoaderBackground label='Getting features ...'/>  }
                    {stagingLoading && <LoaderBackground label='Getting InBox data...'/>}
                    {statusLoading && <LoaderBackground label='Getting commit status...'/>}
                    {commitsLoading && <LoaderBackground label='Getting commits...'/>}
                </FlexCenter>
            </BackgroundLoaderWrapper>

            <Modal modalKey="websocketProcessModal" hasCloseIcon = {false}>
                <LoaderForModal size={30} label={receivedMessage.text} />
            </Modal>
            <DragAndDropContextWrapper>
                <Allotment defaultSizes={[20, 100]} separator>
                    <Allotment.Pane minSize={200} maxSize={600}>

                        <ProjectTreePanel />
                    </Allotment.Pane>
                    <Allotment.Pane>
                        <SpacingCustom paddingLeft={.5}>
                            <Outlet />
                        </SpacingCustom>
                    </Allotment.Pane>
                </Allotment>
            </DragAndDropContextWrapper>
            {/* <DragAndDropContextWrapper>
                <DragLayout firstElement={<ProjectTreePanel />} secondElement={<Outlet />} minWindowSize={350} />
            </DragAndDropContextWrapper> */}
        </section>
    );
};
